import React from 'react';
import RichTextEditor from 'react-rte';
import {useRte} from './hooks/useRte';
import Icon from './components/RteIcon';
import Dialog from './components/RteDialog';
import {getTopDialogZindex} from '../../_shared/GWTBridge/invoke/priModalDlg';
import {isReconTabledFilled} from '../../_shared/GWTBridge/invoke/recon';
import {ScreenLocker} from '../../features/Form/components/ScreenLocker';
import styles from './styles.module.scss';

export const RTEDialog = () => {
    const {
        isOpen,
        htmlValue,
        isLoading,
        handleOpen,
        setHtmlValue,
        handleSave,
        handleClose,
        handleAbortGetText
    } = useRte(RichTextEditor);

    return (
        <div className={styles.rteIcon}>
            <Icon onOpen={handleOpen} isDisabled={!isReconTabledFilled() || isLoading} />

            {isOpen && !isLoading && (
                <Dialog
                    isOpen={isOpen}
                    htmlValue={htmlValue}
                    onChangeHtmlValue={setHtmlValue}
                    onSave={handleSave}
                    onClose={handleClose}
                />
            )}
            <ScreenLocker
                showLoader={isLoading}
                locked={isLoading}
                toggleLoader={handleAbortGetText}
                zIndex={Number(getTopDialogZindex())}
            />
        </div>
    );
};
